import './index.css';

export default {
  name: 'AdragBox',
  props: {
    id: { type: String, default: () => (`a-drag-box-${Math.random().toString().substring(2)}`) },
    prompt: { type: String, default: () => '按住进行拖放' },
    dragType: { type: String, default: () => 'text/plain' },
    draggable: { type: Boolean, default: () => true },
    insert: { type: Boolean, default: () => false },
    color: { type: String, default: () => '' },
    padding: { type: String, default: () => '0' },
    height: { type: String, default: () => '100%' },
    background: { type: String, default: () => '' },
    styles: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: () => false },
  },
  methods: {
    dragstart(a) {
      if (this.draggable) {
        a.dataTransfer.setData(this.dragType, this.id);
        this.$store.commit('setDragId', this.id);
        this.$emit('dragstart', a);
      }
    },
    dragenter(a) {
      a.preventDefault();
      this.$emit('dragenter', a);
    },
    dragleave(a) {
      a.preventDefault();
      this.$emit('dragleave', a);
    },
    dragover(a) {
      a.preventDefault();
      this.$emit('dragover', a);
    },
    dragend(a) {
      a.preventDefault();
      this.$emit('dragend', a);
    },
    drag(a) {
      a.preventDefault();
      this.$emit('drag', a);
    },
    drop(a) {
      a.preventDefault();
      if (this.draggable) {
        const id = a.dataTransfer.getData(this.dragType);
        const draging = document.getElementById(id);
        const droping = document.getElementById(this.id);
        if (draging !== droping) {
          let dragPostion = draging.getBoundingClientRect();
          let dropPostion = droping.getBoundingClientRect();
          if (this.insert) {
            if (this.getIndex(draging) > this.getIndex(droping)) {
              this.$el.parentNode.insertBefore(draging, droping);
            } else {
              this.$el.parentNode.insertBefore(draging, droping.nextSibling);
            }
          }
          this.animate(draging, dragPostion);
          this.animate(droping, dropPostion);
        }
        this.$store.commit('setDropId', this.id);
        this.$emit('drop', a);
      }
    },
    getIndex(element = null) {
      let index = 0;
      if (!element) return -1;
      while (element = element.previousSibling) index++;
      return index;
    },
    animate(element, postion, delay = 300) {
      let current = element.getBoundingClientRect();
      let action = (() => {
        element.style.transition = 'none';
        element.style.transform = `translate3d(${postion.left - current.left}px, ${postion.top - current.top}px, 0)`
        element.offsetWidth;
        element.style.transition = `all ${delay}ms`;
        element.style.transform = 'translate3d(0, 0, 0)';
      })();
      let timeout = null;
      if (timeout) {
        action = null;
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          action = null;
          clearTimeout(timeout);
          timeout = null;
        }, delay);
      }
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div
        id={this.id}
        class="a-drag-box"
        title={this.prompt}
        v-loading={this.loading}
        draggable={this.draggable}
        on-dragstart={this.dragstart}
        on-dragenter={this.dragenter}
        on-dragleave={this.dragleave}
        on-dragover={this.dragover}
        on-dragend={this.dragend}
        on-drag={this.drag}
        on-drop={this.drop}
        style={{ color: this.color, minHeight: this.height, background: this.background, ...this.styles }}
        {...{ attrs }}
      >
        <div class="a-drag-box-body" style={{ padding: this.padding }}>
          <div class="custom-body">{this.$slots.default}</div>
        </div>
      </div>
    );
  }
}